import Api from "../../../services/Api";
import { sanitizeSerialPathParam } from "../../../lib/utils/apiValidation";

function fetchChargerEvents(serialNumber, params) {
  const serial = sanitizeSerialPathParam(serialNumber);
  return Api.get(`/service/iqevse-csms/api/v1/ev_chargers/${serial}/recent_events`, {
    ...params,
  });
}

export { fetchChargerEvents };
